import styled from "styled-components";

 export const FooterContent = styled.div`
  display: flex;
  justify-content: flex-end;

  button:not(:first-child) {
    margin-left: 15px;
  }
  * {
    font-size: 14px;
  }
`;

export const ModalWrapper = styled.div`
  width: 100%;
  height: 70vh;

  display: flex;
  background: #f8f8f8;
`;

export const ItemsPanel = styled.div`
  width: 290px;
  border-right: 1px solid #ededed;
  background: #ffffff;

  display: flex;
  flex-direction: column;
  align-items: stretch;
`

export const PanelHeader = styled.div`
  padding: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: 1px solid #ededed;

  font-size: 14px;
  font-weight: 500;
  color: #424242;

  .items {
    span {
      color: #949494;
      font-size: 13px;
    }
  }

  button {
    border: 0;
    cursor: pointer;
    background: transparent;
    color: #44ADF8;

    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`

export const PanelItem = styled.button`
  background: transparent;
  width: 100%;
  border: 0;
  cursor: pointer;
  text-align: left;
  padding: 10px 30px 10px 14px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  position: relative;

  .index {
    color: #BCBCBC;
    text-align: right;
    min-width: 13px;
  }

  .title {
    max-height: 69px;
    height: auto;
    overflow: hidden;
  }

  div {
    margin-left: auto;

    img {
      visibility: visible;
      align-self: center;
    }
  }

  ${props => props.isActive && `
    background: #F6FAFE;
    font-weight: 500;

    ::before {
      content: '';
      position: absolute;
      height: calc(100% - 4px);
      top: 50%;
      left: 0;
      transform: translate(-50%, -50%);
      width: 4px;
      border: 1px solid #50AFF4;
      border-radius: 3px;
      background: #50AFF4;
    }
  `}
`

export const EmptyFaqWrapper = styled.div`
  background-color: #f6fafe;
  color: #3C3C3C;
  
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h4 {
    margin-top: 22px;
    font-size: 18px;
  }

  p {
    margin-top: 18px;
    color: #666666;
    font-size: 15px;
  }
`

export const AddNewFaqTooltip = styled.div`
  width: 244px;
  position: absolute;
  top: 100%;
  left: calc(100% - 72px);

  padding: 12px 16px;
  border-radius: 3px;
  background-color: #50AFF4;
  color: #ffffff;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;

  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);

  ::before {
    position: absolute;
    bottom: calc(100% - 5px);
    left: 16px;
    content: "";
    height: 10px;
    width: 10px;
    background-color: #50AFF4;
    transform: rotate(45deg);
  }
`